import { Button, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import React, { Children } from 'react';

const styles = makeStyles({
  container: {
    display: 'flex',
    flexWrap: 'nowrap',
    overflowX: 'auto',
  },
  button: {
    margin: '0 5px',
    textTransform: 'capitalize',
    height: '45px',
    minWidth: '45px',
    '&.selected': {
      backgroundColor: '#7F6944',
      color: '#FFFFFF',
    },
  },
});
const ButtonsRadioSelector = ({
  options,
  getLabel,
  onSelect,
  getSelected,
  multiple,
  value,
  getValue,
}) => {
  const classes = styles();
  return (
    <div className={classes.container}>
      {Children.toArray(
        options?.map((item) => (
          <Button
            variant='outlined'
            className={clsx(
              classes.button,
              getSelected?.(item, value) && 'selected'
            )}
            onClick={() => {
              if (getSelected && getSelected(item, value) && onSelect) {
                if (multiple) {
                  onSelect(value.filter((v) => getValue(v) !== getValue(item)));
                } else {
                  onSelect(null);
                }
              } else {
                if (multiple) {
                  onSelect([...(value ?? []), item]);
                } else {
                  onSelect(item);
                }
              }
            }}
            key={item.id}
          >
            {getLabel?.(item)}
          </Button>
        ))
      )}
    </div>
  );
};
export default ButtonsRadioSelector;
